import { PageTitle } from "../../components/PageTitle";
import { SettingsPage } from "./components/SettingsPage/SettingsPage";

const settingsBreadcrumbs = [
  {
    title: "Organization",
    path: "",
    isSeparator: false,
    isActive: true,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const SettingsWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={settingsBreadcrumbs} pageTitle="Settings" />
      <SettingsPage />
    </>
  );
};

export { SettingsWrapper };
